import { createContext, use } from 'react';
import { makeTranslator, type Translate } from '@/i18n/t';

/**
 * The context, split from the provider so a component importing `useT` does not drag the
 * provider's Query hooks into its module graph — the same split `auth/context.ts` makes.
 */
export const I18nContext = createContext<Translate | null>(null);

/**
 * The default is a real `en` translator rather than `null`, and that is load-bearing for
 * one component: `ErrorBoundary` renders *after* something in the tree threw, which may be
 * the provider itself. A boundary that crashed on a missing context would replace a broken
 * page with a blank one.
 */
const FALLBACK = makeTranslator('en', {});

export function useT(): Translate {
  return use(I18nContext) ?? FALLBACK;
}
